import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form"
export default class extends Controller {
	connect() {
	}

	update(event) {
		const { params: { payload } } = event

		const button = document.createElement("button")
		Object.assign(button, payload)

		button.type = "submit"
		button.style.display = "none"

		this.element.append(button)
		this.element.requestSubmit(button)
		button.remove()
	}
}
